import { atom } from 'recoil';

export const aIsAudioDeviceSetVisible = atom<boolean>({
    key: 'aIsAudioDeviceSetVisible',
    default: false
});
